<template>
  <div class="padding-20" style="height: calc(100vh - 200px);background-color: #FFFFFF">
    <div class="display-flex jc-space-between ai-center">
      <div>
        <b class="fs-18">系统列表</b>
        <p class="fs-12 mt-28">共<span class="color-primary"> {{sysList.length}}</span>个系统</p>
      </div>
      <el-button @click="add" type="primary" icon="el-icon-plus">新增系统</el-button>
    </div>
    <div class="sysList">
        <div class="sysList_item"  v-for="item in sysList" :key="item.id">
          <div class="shang display-flex  ai-center">
            <img :src="item.logoUrl" height="52" width="52" class="mr-16"/>
            <div class="display-flex fd-column" >
              <b class="fs-16 mb-14">{{item.name}}</b>
              <el-tooltip effect="dark" :content="item.remark" placement="top">
                <span class="text-ellipsis fs-12 ">{{ item.remark}}</span>
              </el-tooltip>
            </div>
          </div>
          <p class="zhong shang display-flex ai-center jc-space-between  padding-10" style="background-color: #F4F4F4;border-radius: 4px; ">
            <span class="color-info fs-14">开通企业 (家)</span>
            <span class="fs-24 mr-16" >{{item.tenantSize}}</span>
          </p>
          <div class="xia" style="float: right">
            <span @click="edit(item)" class="mr-28 cursor-pointer"><i class="el-icon-edit-outline color-primary" style="margin-right: 10px"></i>编辑</span>
            <span @click="del([item.id])" class="mr-28 cursor-pointer"><i class="el-icon-delete color-warning " style="margin-right: 10px"> </i>删除</span>
          </div>
        </div>
    </div>
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      width="660px">
        <el-form
           :model="dialog.form"
           :rules="rules"
           ref="dialogForm"
           class="no-mb-formItem"
           label-width="100px"
           label-position="top">
          <el-form-item label="系统logo" class="uploadLogo" prop="logoUrl" style="position: relative">
            <el-upload
              accept=".jpg,.jpeg,.png,.JPG,.JPEG"
              drag
              :http-request="imgUpload"
              class="img-upload"
              action=""
              :show-file-list="false">
              <div v-if="dialog.form.logoUrl" style="position: relative">
                <img :src="dialog.form.logoUrl" class="avatar">
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="系统名称"  prop="name">
            <el-input v-model="dialog.form.name" autocomplete="off"></el-input>
          </el-form-item>
          <div class="girdLayout">
              <el-form-item label="code"  prop="code">
                <el-input v-model="dialog.form.code" ></el-input>
              </el-form-item>
              <el-form-item label="登录地址"  prop="callbackUrl">
                <el-input v-model="dialog.form.callbackUrl" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="排序"  prop="sort" >
                <el-input-number v-model="dialog.form.sort" :precision="0" :min="1" class="width-percent-100"></el-input-number>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="dialog.form.remark" placeholder="请输入备注" class="width-percent-100"></el-input>
              </el-form-item>
          </div>
        </el-form>
      <template #footer>
        <el-button @click="dialog.show = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading" >确认</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import * as url from '../../assets/images/login/login_left.png';
export default {
  name: 'Index',
  components: { },
  props: {},
  data () {
    return {
      loading: false,
      dialog: {
        title: '',
        show: false,
        form: {
          id: '',
          sort: 1,
          logoUrl: '',
          logoKey: '',
          name: '',
          aesKey: '',
          code: '',
          appSecret: '',
          callbackUrl: '',
          token: '',
          remark: ''
        }
      },
      rules: {
        logoUrl: [
          { required: true, message: '请选择logo图片', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入添加系统的名称', trigger: 'blur' }
        ],
        aesKey: [
          { required: true, message: '请输入aesKey', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入appKey', trigger: 'blur' }
        ],
        appSecret: [
          { required: true, message: '请输入appSecret', trigger: 'blur' }
        ],
        callbackUrl: [
          { required: true, message: '请输入callbackUrl', trigger: 'blur' }
        ],
        token: [
          { required: true, message: '请输入token', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      imgData: url,
      sysList: []
    }
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {
    add () {
      this.dialog.show = true
      this.dialog.title = '新增系统'
      this.dialog.form = {
        sort: 1,
        logoUrl: '',
        logoKey: '',
        name: '',
        aesKey: '',
        code: '',
        appSecret: '',
        callbackUrl: '',
        token: '',
        remark: ''
      }
    },
    edit (item) {
      console.log(item)
      this.dialog.show = true
      this.dialog.title = '编辑系统'
      this.dialog.form = {
        id: item.id,
        sort: item.sort,
        code: item.code,
        logoUrl: item.logoUrl,
        logoKey: item.logoKey,
        name: item.name,
        // aesKey: item.aesKey,
        // appKey: item.appKey,
        // appSecret: item.appSecret,
        callbackUrl: item.visitUrl,
        // token: item.token,
        remark: item.remark
      }
    },
    del (ids) {
      console.log(ids)
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.product.deleteSystem(ids).then(res => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {
      });
    },
    // 图片上传
    imgUpload (e) {
      const formData = new FormData()
      for (const file of [e.file]) {
        formData.append('file', file, file.name);// 三个参数分别对应key value和文件名
      }
      this.$api.product.uploadLogo(formData).then(res => {
        this.dialog.form.logoUrl = res.url
        this.dialog.form.logoKey = res.key
      })
    },
    // 获取数组列表
    getList () {
      this.$api.product.list().then(res => {
        this.sysList = res
      })
    },
    // 提交表单
    submitForm () {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const data = {
            code: this.dialog.form.code,
            sort: this.dialog.form.sort,
            visitUrl: this.dialog.form.callbackUrl,
            name: this.dialog.form.name,
            logoKey: this.dialog.form.logoKey,
            remark: this.dialog.form.remark
          }
          if (this.dialog.form.id) {
            data.id = this.dialog.form.id
            this.$api.product.update(data).then(() => {
              this.$message.success('编辑成功')
              this.$refs.dialogForm.resetFields();
              this.dialog.show = false
              this.loading = false
              this.getList()
            }).catch(() => {
              this.loading = false
            })
          } else {
            this.$api.product.save(data).then(() => {
              this.$message.success('创建成功')
              this.$refs.dialogForm.resetFields();
              this.dialog.show = false
              this.loading = false
              this.getList()
            }).catch(() => {
              this.loading = false
            })
          }
        }
      });
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.getList()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.sysList{
  display: grid;
  grid-template-columns: repeat(auto-fill,312px);
  grid-gap: 20px;
  background-color: #FFFFFF;
  .sysList_item{
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #D9D9D9;

  }
}
.img-upload {
  display: flex;
  flex-direction: column;
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409EFF;
    }
    .el-upload-dragger {
      border: none;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      i {
        font-size: 22px;
        color: #999999;
      }
      p {
        margin-bottom: 0;
      }
    }
  }
  .avatar {
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: block;
  }
}

::v-deep
.no-mb-formItem{
  .el-form-item{
    margin-bottom: 0;
    .el-form-item__label{
      padding:0!important;
    }
  }
}
.girdLayout{
   display: grid;
   grid-template-columns: 1fr 1fr;
   column-gap: 30px
}
::v-deep
.el-dialog__body{
  padding: 0 20px!important;
}
</style>
